module.exports = __webpack_public_path__ + "static/media/big-cash-vouchar.14de3447.png";